module.exports = __webpack_public_path__ + "static/LCScriptWeb-Regular-12e931218cd23df325f3285f6c5f1398.woff";